import styles from './LoginRedirect.module.css';

import React from 'react';
import { commentsLogin, commentsSignUp } from 'lib/analytics';
import Link from 'next/link';

export default function LoginRedirect() {
  if (typeof window === 'undefined') return null;
  const redirectParam = encodeURIComponent(window.location.pathname);
  const loginHref = `/login/?redirect=${redirectParam}`;
  const registerHref = `/signup/?redirect=${redirectParam}`;
  return (
    <div className={styles.LoginRedirect}>
      <Link
        href={loginHref}
        className={styles.LoginRedirectButton}
        onClick={() => {
          commentsLogin();
          return true;
        }}
      >
        Log in
      </Link>{' '}
      or{' '}
      <Link
        href={registerHref}
        className={styles.LoginRedirectSignUpButton}
        onClick={() => {
          commentsSignUp();
          return true;
        }}
      >
        <strong>sign up</strong>
      </Link>{' '}
      to comment
    </div>
  );
}
